module.exports = __webpack_public_path__ + "static/zoma_slovakia_privacy-22537fc5ba79ef1e974687afe0f516af.pdf";